import { Routes } from '@angular/router';
import { AccountPickerComponent } from './components/account-picker/account-picker.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AdminComponent } from './components/admin/admin.component';

export const routes: Routes = [
  { path: '',          component: AccountPickerComponent },
  { path: 'login',     component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'admin',     component: AdminComponent },
  { path: 'hitlist',   loadComponent: () => import('./components/dashboard/hit-list/hit-list.component').then(m => m.HitListComponent) },
  { path: '**',        redirectTo: '' }
];
